import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faVolumeHigh,
  faVolumeLow,
  faVolumeXmark,
} from "@fortawesome/free-solid-svg-icons";
import {
  getVolume,
  onVolumeChange,
  setVolume,
  soundOn,
  tone,
} from "../audio/audioEngine";
import { volumeBadgeMs, volumeSteps } from "../constants";

const volumeKeys = { ArrowUp: 1, ArrowDown: -1 };

// Shift+pijltje omhoog/omlaag: volume een stap hoger/lager. Zonder Shift blijven de
// pijltjes van de maandnavigatie in Navbar.js, die Shift juist negeert.
const VolumeBadge = () => {
  const [level, setLevel] = useState(getVolume);
  const [visible, setVisible] = useState(false);

  useEffect(() => onVolumeChange(setLevel), []);

  useEffect(() => {
    let timer = null;

    const onKey = (event) => {
      const step = volumeKeys[event.key];
      if (!step || !event.shiftKey) return;
      if (event.metaKey || event.ctrlKey || event.altKey) return;
      const tag = event.target?.tagName;
      if (tag === "INPUT" || tag === "TEXTAREA" || event.target?.isContentEditable) return;

      event.preventDefault();
      const next = setVolume(getVolume() + step);
      // Een tikje op het nieuwe volume, zodat je hoort waar je staat.
      if (next > 0) tone({ freq: 880, duration: 0.12, gain: 0.25 });

      setVisible(true);
      clearTimeout(timer);
      timer = setTimeout(() => setVisible(false), volumeBadgeMs);
    };

    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("keydown", onKey);
      clearTimeout(timer);
    };
  }, []);

  if (!visible) return null;

  const muted = level === 0 || !soundOn();
  const icon = muted ? faVolumeXmark : level * 2 > volumeSteps ? faVolumeHigh : faVolumeLow;

  return (
    <span className="volume-badge" aria-live="polite">
      <FontAwesomeIcon icon={icon} className="vb-icon" />
      <span className="vb-steps">
        {Array.from({ length: volumeSteps }, (_, index) => (
          <span key={index} className={index < level ? "vb-step is-on" : "vb-step"} />
        ))}
      </span>
      <span className="vb-label">{soundOn() ? level : "uit"}</span>
    </span>
  );
};

export default VolumeBadge;
